<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">계약관리</span>
            <span class="txt">핏투데이케어에 가입한 업체 계약 및 결제정보 등록, 수정, 삭제가 가능합니다.</span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-radio">
                    <input
                        id="radio-day-1"
                        :checked="dateFilterType === 'C'"
                        name="radio-day"
                        type="radio"
                        @click="dateFilterType = 'C'"
                    />
                    <label class="w110" for="radio-day-1">계약일</label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="onUpdateContractDate"
                />

                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="이름 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>

            <div class="line">
                <div class="com-radio">
                    <input
                        id="radio-day-2"
                        :checked="dateFilterType === 'E'"
                        name="radio-day"
                        type="radio"
                        @click="dateFilterType = 'E'"
                    />
                    <label class="w110" for="radio-day-2">만료일</label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="expireStartDate" @update="onUpdateExpireStartDate" />
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="expireEndDate" @update="onUpdateExpireEndDate" />
                </div>
                <select-form
                    :select-data="['선택', ...expireDayTypeList]"
                    :select-value="['', ...expireDayTypeValueList]"
                    :selected-value="expirePeriod"
                    @update:set="onUpdateExpirePeriod"
                />
            </div>

            <div class="line">
                <select-form
                    :select-data="['계약유형', ...contractTypeList]"
                    :select-value="['', ...contractTypeValueList]"
                    :selected-value="contractType"
                    @update:set="(val) => (contractType = val)"
                ></select-form>
                <select-form
                    :select-data="['계약상태', ...contractStatusList]"
                    :select-value="['', ...contractStatusValueList]"
                    :selected-value="contractStatus"
                    @update:set="(val) => (contractStatus = val)"
                ></select-form>
                <select-form
                    :select-data="['업종선택', ...bizTypeList]"
                    :select-value="['', ...bizTypeValueList]"
                    :selected-value="bizType"
                    @update:set="(val) => (bizType = val)"
                ></select-form>
                <select-form
                    :select-data="['상품명', ...programList]"
                    :select-value="['', ...programIdList]"
                    :selected-value="programId"
                    @update:set="onUpdateProgramId"
                ></select-form>
                <!--
                * 2021.03.14, notbadlife@eb, 페이지 요건 변경으로 제거
                <select-form :select-data='["문자가입여부", ...messageJoinTypeList]'
                             :select-value="['', ...messageJoinTypeValueList]"
                             @update:set="val => messageJoinType = val"
                             :selected-value="messageJoinType"></select-form>
                -->
                <button class="com-search-reset" @click="reset"></button>
            </div>
        </div>
        <div class="com-btn-area">
            <div class="left-box">
                <button class="com-btn excel">엑셀다운로드</button>
            </div>
            <div class="right-box">
                <a class="com-btn" href="/madmin/business/contract/edit">계약등록</a>
                <a class="com-btn blue" href="/madmin/business/contract/product">상품설정</a>
            </div>
        </div>
        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 140px" />
                    <col style="width: 220px" />
                    <col style="width: 140px" />
                    <col style="width: 100px" />
                    <col style="width: 240px" />
                    <col style="width: 240px" />
                    <col style="width: 120px" />
                    <!--
                    <col style='width:220px;'>
                    <col style='width:120px;'>-->
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>최신계약일</button>
                        </th>
                        <th>
                            <button>센터명</button>
                        </th>
                        <th>
                            <button>계약유형</button>
                        </th>
                        <th>
                            <button>업종</button>
                        </th>
                        <th>
                            <button>프로그램명</button>
                        </th>
                        <th>
                            <button>프로그램 사용기간</button>
                        </th>
                        <!--
                    <th><button>문자</button></th>
                    <th><button>문자 사용기간</button></th>
                    -->
                        <th>
                            <button>계약상태</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(c, index) in contractList" :key="index">
                        <td>{{ c.c_contract_dt | timestampFilter }}</td>
                        <td>
                            <a :href="`/madmin/business/contract/detail/${c.c_center_id}`" class="link">
                                {{ c.c_center_nm }}
                                <span v-show="c.c_chain_id !== null" class="ic">체인</span>
                            </a>
                        </td>
                        <td>{{ getContractTypeString(c.c_contract_type_cd) }}</td>
                        <td>{{ getBizTypeString(c.c_biz_type_cd) }}</td>
                        <td>{{ c.cp_ft_prod_nm !== null ? c.cp_ft_prod_nm : '-' }}</td>
                        <td>
                            <span class="info-line">
                                <span v-if="c.cp_contract_start_dt !== null">
                                    {{ c.cp_contract_start_dt | timestampFilter }} ~
                                    {{ c.cp_contract_end_dt | timestampFilter }}
                                </span>
                                <span
                                    v-if="c.cp_diff_day !== null"
                                    :class="['expire', c.cp_diff_day <= limitAlertDay ? 'red' : '']"
                                >
                                    {{ getPeriodString(c.cp_diff_day) }}
                                </span>
                            </span>
                        </td>
                        <!--
                    <td>{{ c.sms_ft_prod_nm !== null ? c.sms_ft_prod_nm : '' }}</td>
                    <td>
                        <span class="info-line">
                            <span v-if="c.sms_contract_start_dt !== null">{{ c.sms_contract_start_dt | timestampFilter }} ~ {{ c.sms_contract_start_dt | timestampFilter }}</span>
                            <span v-if="c.sms_diff_day !== null" :class="['expire', c.sms_diff_day <= limitAlertDay ? 'red' : '']">{{ getPeriodString( c.sms_diff_day ) }}</span>
                        </span>
                    </td>
                    -->
                        <td>{{ getContractStatusString(c.cp_contract_status_cd) }}</td>
                    </tr>
                    <tr v-if="contractList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    :select-value="[10, 20, 50, 100]"
                    :selected-value="pagingInfo.limit"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '../../../../assets/js/api';
import moment from 'moment';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'businessContractList',
    props: {},
    watch: {
        contractType(newValue) {
            this.contractType = newValue;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        contractStatus(newValue) {
            this.contractStatus = newValue;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        bizType(newValue) {
            this.bizType = newValue;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        messageJoinType(newValue) {
            this.messageJoinType = newValue;
            this.pagingInfo.page = 1;
            this.onSearchList();
        },

        dateFilterType(newValue) {
            this.pagingInfo.page = 1;
            this.onSearchList();
        },

        expireStartDate(newValue) {
            if (this.dateFilterType === 'E') {
                this.pagingInfo.page = 1;
                this.onSearchList();
            }
        },
        expireEndDate(newValue) {
            if (this.dateFilterType === 'E') {
                this.pagingInfo.page = 1;
                this.onSearchList();
            }
        },
        expirePeriod(newValue) {
            this.updateExpireDate();
        },
    },
    computed: {
        limitAlertDay: {
            // 만료일을 표시할 기준 날수 지정 : 7일로 지정
            get() {
                return 7;
            },
        },
    },
    data() {
        return {
            isLoading: false,
            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            period: 'S-12-0-months',
            expireStartDate: '',
            expireEndDate: '',
            expirePeriod: '',
            contractType: '',
            contractStatus: '',
            bizType: '',
            messageJoinType: '',
            programId: '',
            contractList: {},
            pagingInfo: { ...pagingInfo },
            statusTypeValueList: ['X', 'O'],
            periodTypeList: ['오늘', '어제', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'S-0-0-days',
                'S-1-1-days',
                'P-0-0-months-month',
                'P-1-1-months-month',
                'S-3-0-months',
                'S-6-0-months',
                'S-12-0-months',
            ],
            expireDayTypeList: ['오늘', '만료 1일 전', '만료 3일 전', '만료 7일 전', '이번 달', '지난 달'],
            expireDayTypeValueList: ['today', '1', '3', '7', 'thisMonth', 'prevMonth'],
            contractTypeList: ['월결제', '선결제'],
            contractTypeValueList: ['M', 'P'],
            contractStatusList: ['종료', '유효'],
            contractStatusValueList: ['X', 'O'],
            bizTypeList: ['헬스장', '필라테스', '요가', 'PT샵', '스포츠시설', '뷰티', '기타'],
            bizTypeValueList: ['H', 'F', 'Y', 'P', 'S', 'B', 'E'],
            messageJoinTypeList: ['전체', '유효', '종료', '미가입'],
            messageJoinTypeValueList: ['T', 'A', 'E', 'N'],
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            programList: [],
            programIdList: [],
            searchStr: '',
            dateFilterType: 'C',
        };
    },
    mounted() {
        this.expirePeriod = 'thisMonth';
        this.pagingInfo.page = 1;

        this.onProgramList();
        this.onSearchList();
    },
    methods: {
        // 센터 검색 API 호출
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getContractList();
                this.setPageParams(data, 'center');
                this.contractList = data.items;
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        async onProgramList() {
            try {
                this.isLoading = true;
                const { data } = await this.getFtProduct();

                for (const item of data) {
                    if (item.f_prod_type_cd === 'P') {
                        this.programList.push(item.f_namee);
                        this.programIdList.push(item.f_id);
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },

        // 센터 목록 조회 API
        getContractList() {
            const {
                startDate,
                endDate,
                bizType,
                contractType,
                contractStatus,
                messageJoinType,
                searchStr,
                expireStartDate,
                expireEndDate,
                dateFilterType,
                programId,
            } = this;

            // 스웨거: FT계약 프로그램 계약목록 조회
            // return api.get('/admin/api/ft/contract', {
            const keyword = searchStr.length < 2 ? '' : searchStr;
            return api.get('/admin/api/ft/contract/program/list', {
                params: {
                    startDate,
                    endDate,
                    contractType,
                    contractStatus,
                    bizType,
                    expireStartDate,
                    expireEndDate,
                    dateFilterType,
                    programId,
                    /*
messageJoinType,
centerType: this.centerType,
status: this.status,
*/
                    keyword,
                    ...this.pagingInfo,
                },
            });
        },

        getFtProduct() {
            return api.get('/admin/api/ft/product');
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
            return startDate;
        },

        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.period = '';

            if (this.dateFilterType === 'C') {
                this.pagingInfo.page = 1;
                this.onSearchList();
            }
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.period = '';

            if (this.dateFilterType === 'C') {
                this.pagingInfo.page = 1;
                this.onSearchList();
            }
        },

        updateExpireDate() {
            if (this.expirePeriod === 'thisMonth') {
                this.expireStartDate = moment().startOf('month').format('YYYY-MM-DD');
                this.expireEndDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (this.expirePeriod === 'prevMonth') {
                this.expireStartDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.expireEndDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (this.expirePeriod === 'today') {
                this.expireStartDate = moment().format('YYYY-MM-DD');
                this.expireEndDate = moment().format('YYYY-MM-DD');
            } else if (this.expirePeriod === '1') {
                this.expireStartDate = moment().format('YYYY-MM-DD');
                this.expireEndDate = moment().add(1, 'days').format('YYYY-MM-DD');
            } else if (this.expirePeriod === '3') {
                this.expireStartDate = moment().format('YYYY-MM-DD');
                this.expireEndDate = moment().add(2, 'days').format('YYYY-MM-DD');
            } else if (this.expirePeriod === '7') {
                this.expireStartDate = moment().format('YYYY-MM-DD');
                this.expireEndDate = moment().add(6, 'days').format('YYYY-MM-DD');
            }
        },

        onUpdateExpireStartDate(val) {
            this.expireStartDate = val;
            this.expirePeriod = '';
        },

        onUpdateExpireEndDate(val) {
            this.expireEndDate = val;
            this.expirePeriod = '';
        },

        onUpdateExpirePeriod(val) {
            this.expirePeriod = val;
            this.dateFilterType = 'E';
        },

        getBizTypeString(bizType) {
            let ret = '';
            switch (bizType) {
                case 'H':
                    ret = '헬스장';
                    break;
                case 'F':
                    ret = '필라테스';
                    break;
                case 'Y':
                    ret = '요가';
                    break;
                case 'P':
                    ret = 'PT샵';
                    break;
                case 'S':
                    ret = '스포츠시설';
                    break;
                case 'B':
                    ret = '뷰티';
                    break;
                case 'E':
                    ret = '기타';
                    break;
            }
            return ret;
        },
        getContractTypeString(contractType) {
            let ret = '';
            switch (contractType) {
                case 'M':
                    ret = '월 결제';
                    break;
                case 'P':
                    ret = '선 결제';
                    break;
            }
            return ret;
        },
        getContractStatusString(contractStatus) {
            let ret = '';
            switch (contractStatus) {
                case 'O':
                    ret = '유효';
                    break;
                case 'X':
                    ret = '종료';
                    break;
            }
            return ret;
        },
        getPeriodString(period) {
            if (period < 0) {
                return '사용종료';
            } else if (period == 0) {
                return '당일만료';
            } else if (period <= this.limitAlertDay) {
                return `만료 ${period}일 전`;
            }
            return `${period}일 남음`;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 이벤트 발생시 키워드 길이 체크
        onEventSearch() {
            this.onSearchList();
        },
        onUpdateContractDate(data) {
            this.period = data;
            this.pagingInfo.page = 1;
            if (data === '') return;

            const array = data.split('-');

            const funcType = array[0]; // S: subtract 함수를 이용 P: startOf와 endOf함수를 이용
            const startValue = Number(array[1]);
            const endValue = Number(array[2]);
            const type1 = array[3];
            const type2 = funcType === 'P' ? array[4] : '';

            if (funcType === 'S') {
                this.startDate = moment().subtract(startValue, type1).format('YYYY-MM-DD');
                this.endDate = moment().subtract(endValue, type1).format('YYYY-MM-DD');
            } else if (funcType === 'P') {
                this.startDate = moment().subtract(startValue, type1).startOf(type2).format('YYYY-MM-DD');
                this.endDate = moment().subtract(endValue, type1).endOf(type2).format('YYYY-MM-DD');
            }
            this.dateFilterType = 'C'; // 날짜 필터링의 기준을 계약일자로 설정함.

            this.onSearchList();
        },
        onUpdateProgramId(value) {
            this.programId = value;
            this.onSearchList();
        },
        reset() {
            this.period = 'S-12-0-months';
            this.contractType = '';
            this.contractStatus = '';
            this.bizType = '';
            this.searchStr = '';
            this.programId = '';
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.expirePeriod = 'thisMonth'

            this.onSearchList();
        },
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },
    },
};
</script>
<style lang="scss"></style>
